import {
  isOnlyMissingPoolCompleteRequirement,
  resolvePoolJob,
  type PoolJobResolution,
} from './poolJobCta';
import { useMissingConditionsCg } from './useMissingConditionsCg';
import { useProfessionalPoolContext } from './useProfessionalPoolContext';

export * from './poolJobCta';

export type PoolJobCtaJob = {
  id?: number | null;
  pool_id?: number | null;
  can_book_job?: boolean | null;
  pool?: { id?: number | null; requires_pro_review?: boolean | null } | null;
} | null;

export type UsePoolJobCtaResult = PoolJobResolution & {
  isLoading: boolean;
};

export const usePoolJobCta = (job: PoolJobCtaJob): UsePoolJobCtaResult => {
  const poolId = job?.pool_id ?? null;
  const isPoolJob = poolId !== null && poolId !== undefined;

  const poolContext = useProfessionalPoolContext(poolId);
  const { conditions, isLoading: conditionsLoading } = useMissingConditionsCg({
    job_id: job?.id ?? undefined,
    enabled: isPoolJob,
  });

  if (!isPoolJob) {
    return { cta: null, action: 'none', isLoading: false };
  }

  const resolution = resolvePoolJob({
    poolId,
    canBookJob: job?.can_book_job,
    requiresProReview: job?.pool?.requires_pro_review,
    hasPoolPq: poolContext.hasPoolPq,
    onboardingStatus: poolContext.poolOnboardingStatus,
    onboardingStatusUnavailable: poolContext.onboardingStatusUnavailable,
    onlyMissingPoolComplete: isOnlyMissingPoolCompleteRequirement(poolId, conditions),
  });

  return { ...resolution, isLoading: poolContext.isLoading || conditionsLoading };
};
